import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { isNewbuildingConsultantPopupAvailable } from '../../../../selectors/newbuildingConsultant';
import { applyAdvanced } from '../../../state/advanced/apply';
import { closeAdvancedModal } from '../../../state/advanced/toggle_modal';
import { newbuildingOpenConsultantPopup } from '../../../../serp/state/newbuildingConsultant';
import { AdvancedModalFooter } from './index';

export const mapStateToProps = (state: IAppState) => ({
  jsonQueryUrl: state.filters.jsonQueryUrl,
  newbuildingConsultantPopup: isNewbuildingConsultantPopupAvailable(state),
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClick: () => dispatch(applyAdvanced()),
  openChat: () => {
    dispatch(closeAdvancedModal());
    dispatch(newbuildingOpenConsultantPopup(true));
  },
});

export const AdvancedModalFooterContainer = connect(mapStateToProps, mapDispatchToProps)(AdvancedModalFooter);
